import { render } from "./CustomToast.vue?vue&type=template&id=3f375e0a"
import script from "./CustomToast.vue?vue&type=script&lang=js"
export * from "./CustomToast.vue?vue&type=script&lang=js"
script.render = render

export default script